<template>
  <div>
    <BasicDialog @close="closeDialog">
      <v-row>



        <v-col cols="12" class="d-flex flex-row justify-center align-center">
          <logo-background></logo-background>
          <div style="position: absolute;" class="d-flex flex-row justify-center align-center">
            <img :src="AppConfigs.staticImages.FACEBOOK" alt="Like us on Facebook" style="width: 70%; height: auto;">
            <img :src="AppConfigs.staticImages.PRIMARYCHECK" v-if="!isAvailable"
              style="position: absolute; top: -45%; left: -20%; width: 60%; height: auto;">
          </div>
        </v-col>



        <v-col cols="12" class="d-flex flex-row justify-center text-center text-h5 font-weight-bold">
          Like us on Facebook
        </v-col>



        <v-col cols="12" class="text-center">
          Like us on Facebook and earn {{ coinsForLikingOnFacebook }} coins
        </v-col>



        <v-col cols="12" class="d-flex flex-row justify-center">
          <v-btn rounded="pill" :disabled="!isAvailable"
            class="  button--primary text-h6 font-weight-medium pl-6 pr-6 py-6 d-flex"
            @click="likeOnFacebook">
            Like Now
          </v-btn>
        </v-col>



      </v-row>
    </BasicDialog>
  </div>
</template>

  


<script>

import { defineComponent } from 'vue';
import { AppConfigs } from "@/app.configs";
import { computed, inject, provide } from 'vue';
import { UserActivityStore } from '@/store/UserActivityStore';

import LogoBackground from "@/icons/LogoBackground.vue";
import BasicDialog from "@/components/Common/Basic-Dialog.vue";

export default defineComponent({
  name: 'LikeUsOnFacebookDialog',
  components: {
    BasicDialog,
    LogoBackground,
  },
  setup(props, { emit }) {

    const inHouseTaskStore = UserActivityStore();
    let openDialog = inject('inHouseTaskOpenDialog');
    provide('openDialog', openDialog);
    const coinsForLikingOnFacebook = computed(() => inHouseTaskStore.selectedInHouseTask.coins_amount);
    const isAvailable = computed(() => inHouseTaskStore.selectedInHouseTask.availability_info.is_available);

    const facebookPageUrl = 'https://www.facebook.com/BountyHunterRewards';

    function closeDialog() {
      emit('close');
    }

    function likeOnFacebook() {
      window.open(facebookPageUrl, '_blank');
      inHouseTaskStore.redeemCoinsForSelectedInHouseTask();
    }

    return {
      AppConfigs,
      closeDialog,
      isAvailable,
      likeOnFacebook,
      coinsForLikingOnFacebook,
    };
  },
});
</script>
